<template>
  <ap-layout :state="state">
    <div>
      <form
        class="ba-relative ba-w-full md:ba-w-116 ba-mt-8"
        @submit.prevent="loginFormSubmit"
      >
        <ap-input
          v-model="form.username"
          :name="$t('login.formUserName')"
          :disabled="formLoading"
          autocomplete="on"
        />
        <ap-input
          v-model="form.password"
          :disabled="formLoading"
          type="password"
          :name="$t('login.formPasswd')"
          autocomplete="on"
        />

        <div class="md:ba-flex ba-justify-between ba-items-center ba-mt-8">
          <ap-checkbox
            v-model="form.rememberMe"
            :disabled="formLoading"
            :label="$t('login.formRememberMe')"
          />
          <router-link
            v-if="settings.canRemember"
            :to="{ name: 'recovery', query: { state } }"
            class="ba-inline-block ba-mt-3 md:ba-mt-0 ba-text-base md:ba-text-xl ba-underline ba-text-blue ba-leading-none"
            >{{ $t("login.recoveryPassword") }}
          </router-link>
        </div>

        <ap-captcha
          v-if="showCaptcha"
          class="ba-mt-15"
          :result.sync="captchResult"
          :refresh.sync="refreshCaptcha"
        />

        <ap-error
          v-if="message"
          class="ba-absolute ba-inset-x-0 ba-mt-3 md:ba-mt-5"
          :message="message"
          :success="formSuccess"
        />

        <button
          class="ap-button-login ba-mt-15 ba-mx-auto ba-transition-all"
          type="submit"
          :class="[formLoading || isDisabled ? 'ba-bg-faint ap-button-login__disabled' : isHover && !isDisabled ? 'ba-bg-accent':'artek-gradient-light']"
          @mouseenter="isHover = true"
          @mouseleave="isHover = false"
        >
          {{ $t("button.login") }}
        </button>
      </form>
    </div>
  </ap-layout>
</template>

<script>
import ApLayout from "@/components/artek/ap-layout";
import ApInput from "@/components/artek/ap-input";
import ApCheckbox from "@/components/artek/ap-checkbox";
import { loginMixin } from "@ba/visary-account-common-vue";
import { createSettings } from "@/utils/settings";
import ApCaptcha from "@/components/artek/ap-captcha";
import ApError from "@/components/artek/ap-error";

export default {
  mixins: [loginMixin],
  components: {
    ApError,
    ApCaptcha,
    ApLayout,
    ApCheckbox,
    ApInput
  },
  data() {
    return {
      settings: createSettings(),
      isHover: false
    };
  },
  computed: {
    message() {
      if (this.formError) {
        return this.$t("login.formError");
      }
      if (this.formSuccess) {
        return this.$t("login.formSuccess");
      }
      return "";
    },
    isDisabled() {
      return !this.form.username || !this.form.password;
    }
  },
  watch: {
    loginInfo() {
      this.settings = createSettings(this.loginInfo?.clientId);
    }
  }
};
</script>
